
<template>
    <div>
        <div class="row align-items-center">

            <div class="col-lg-6">
                <base-input alternative=""
                    label="Unit Name"
                    placeholder="Enter Unit Name"
                    input-classes="form-control-alternative"
                    v-model="record.name"
                    required
                />
            </div>

            <div class="col-lg-6">
                <base-input alternative=""
                    label="Unit Description"
                    placeholder="Unit Description"
                    input-classes="form-control-alternative"
                    v-model="record.description"
                />
            </div>

            <div
                class="col-sm-12 text-center"
                v-if='showErrorStatus'
            >
                <base-alert :type="errorType">
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                </base-alert>
            </div>

            <hr class="my-4" />

            <div class="col-lg-12">
                <base-button
                    type="success" size="lg"
                    @click="saveUnitRecords()"
                    :disabled="(privileges && privileges.add == 'no') || ! privileges"
                >
                    <i class="fa fa-save"></i>
                    {{isloading ? 'Please Wait...' : isEdit + ' Record'}}
                </base-button>

                <base-button
                    type="danger" size="lg"
                    class="right"
                    @click="$emit('showNewUnit', false)"
                >
                    <i class="fa fa-times"></i>
                    Cancel
                </base-button>
            </div>
        </div>

    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'AddUnit',
        props: ['privileges', 'showNewUnit', 'unit', 'department', 'loadDepartments', 'updateUnits',
                'justAddedUnits'],
        data() {
            return {
                record: {
                    name: null,
                    description: null,
                    id: null,
                    admin_department_id: null,
                    admin_id: null
                },
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false
            }
        },
        computed: {
            isEdit() {
                return this.record && this.record.id ? 'Update' : 'Add';
            }
        },
        methods: {
            ...mapActions(['saveUnit']),
            setData() {// set data for editing
                let unit = this.unit;
                if(unit) {
                    this.record.name = unit.name;
                    this.record.description = unit.description;
                    this.record.id = unit.id;
                }
                this.record.admin_department_id = this.department.id;
            },
            emptyEduRecords() {
                this.record.name = null;
                this.record.code = null;
            },
            saveUnitRecords() {
                let status = this.validatedInputs();// validate inputs
                if(status) {// save department
                    let data = this.record;
                    data.admin_id = this.$store.state.user.userId;// add admin user id
                    data.status = 'enable';
                    this.preloader(); // show loading
                    this.saveUnit(data).then((res) => {// update unit
                        if(res.status) {
                            this.showNewUnit(false);// hide edit page
                            this.justAddedUnits();// hide empty units msg
                            this.reloadUnits(res.units);// update units
                            this.loadDepartments();// refresh page
                            swal.fire("Record "+res.type, res.msg, "success");
                        } else {
                            this.loadDepartments();// refresh page
                            swal.fire("Error Occurred!", res.msg, "warning");
                        }
                    }).
                    catch(err => {
                        this.loadDepartments();// refresh page
                        swal.fire(err.message+"!", "An error occurred while saving, try again", "warning");
                    });
                }
            },
            validatedInputs() {
                let data = this.record;
                data.name == null ? this.showInuptError('Unit\'s Name') : data.name;
                return data.name ? true : false;
            },
            isEmpty(obj) {// check for empty field
                return ! Object.keys(obj).some(k => !obj[k]);
            },
            showInuptError(name) {
                this.isloading = false;
                this.showErrorStatus = true;
                this.errorType = 'warning'
                this.errorMsg = 'Invalid ' + name + ' has been entered';
                var self = this;
                setTimeout(function() { self.showErrorStatus = false; }, 5000);
            },
            reloadUnits(units) {// refresh page
                this.updateUnits(units);
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        mounted() {// set records
            this.setData();
        }
    };
</script>
<style scoped>
    .right {
        float: right;
    }
    .marginTop40 {
        margin-top: 40px;
    }
</style>